
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({
    
    totalOps: 0,
    
});






export const useOpsStore = create()(
    devtools(
        storeApi
    )
)
